enum StatsVersion {
  LATEST = 0
}

export default StatsVersion;